import { CheckoutState } from '../../state';
import {
    getEmailToPrefill,
    getFirstNameToPrefill,
    getLastNameToPrefill,
} from '../../utils/user';
import { getFirstAttendeeWithSurvey } from './pureSelectors';

export const getPrefillFirstAttendeeInfo = (state: CheckoutState) => ({
    emailToPrefill: getEmailToPrefill(state),
    firstNameToPrefill: getFirstNameToPrefill(state),
    lastNameToPrefill: getLastNameToPrefill(state),
    attendeeWithSurvey: getFirstAttendeeWithSurvey(state),
});
